import useMe from 'hooks/useMe';
import { useMemo } from 'react';

import { useActiveLinks } from '../../../../../../hooks';
import { ADMIN_ITEMS, MENU_ITEMS } from '../../../../MyAccount-constants';

const ContainerComponent = ({ children }) => {
  const { me } = useMe();

  const isAdmin = me?.role !== 'company-staff';

  // TODO: Put this back in once other settings pages are ready
  const items = useMemo(
    () => [...MENU_ITEMS, ...(isAdmin ? ADMIN_ITEMS : [])],
    [isAdmin],
  );

  return children({ items: useActiveLinks(items) });
};

ContainerComponent.displayName = 'DesktopLayout-SideBar-container';

export default ContainerComponent;
